import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterSubDistrictsandFOT } from "../../helper-functions";
import { API_URL } from "../../config/sys";
import { FetchRetailers, get } from "../../config/api";

// Simulating an API call
export const fetchAllRetailers = createAsyncThunk(
  "fetchAllRetailers",
  async (data, thunkAPI) => {
    const { dispatch } = thunkAPI;
    dispatch(setLoader(true));
    // INKVM

    get(`/customers?territory_code=${data.territory_id}&fo_id=${data.fo_id}`).then(async (data) => {





      




let reStructuredData = [];
data.map((item)=>{
  reStructuredData.push({
        "customer_id": item.customer_id,
        "shop_name": item.shop_name,
        "customer_name": item.customer_name,
        "mobile_number": item.mobile_number,
        "email_id": item.email_id,
        "sub_district_id":item.upazila_code,
        "sub_district": item.upazila_name,
        "fot": item.zila_name,
        "fot_id": item.zila_code,
        "bibhag_code": item.bibhag_code,
        "bibhag_name": item.bibhag_name,
        "unit_code" : item.unit_code,
        "unit_name" : item.unit_name,
        "territory_id": item.territory_code,
        "territory": item.territory_name,
        "survey_status": item.survey_status,
        "fo_id": null,
       
    })
})






      dispatch(setRetailers({ data: reStructuredData }));
      const subDistrictsandFOT = await filterSubDistrictsandFOT(reStructuredData);
      dispatch(setSubDistricts(subDistrictsandFOT.subdist));
      dispatch(setFOTList(subDistrictsandFOT.fot));



      // const subDistrictsandFOT = await filterSubDistrictsandFOT(data);
      console.log(subDistrictsandFOT,'THE UPDATED BD RET LIST')
      // dispatch(setSubDistricts(subDistrictsandFOT.subdist));
      // dispatch(setFOTList(subDistrictsandFOT.fot));
      dispatch(setLoader(false))
    });
  }
);

const RetailersSlice = createSlice({
  name: "fetchAllRetailers",
  initialState: {
    loading: false,
    error: null,
    retailers: [],
    fot: [],
    subdistrict: [],
  },
  reducers: {
    setRetailers: (state, action) => {
      state.retailers = action.payload.data;
      state.loading = false
    },
    setSubDistricts: (state, action) => {
      state.subdistrict = action.payload;
      
    },
    setFOTList: (state, action) => {
      state.fot = action.payload;
     
    },
    setLoader: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRetailers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllRetailers.fulfilled, (state, action) => {
        // state.loading = true;
      })
      .addCase(fetchAllRetailers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setRetailers, setSubDistricts, setFOTList, setLoader } =
  RetailersSlice.actions;
export default RetailersSlice.reducer;
